import React, { forwardRef, type ForwardedRef } from "react";
import {
  KeyboardDatePicker as MuiKeyboardDatePicker,
  KeyboardDatePickerProps,
} from "@material-ui/pickers";

import { useFullscreenElement } from "src/utils/fullscreen";

/** This is just a wrapper of Mui's KeyboardDatePicker that patches `container` property to make
 * the date picker work in fullscreen mode.
 */
const KeyboardDatePicker = forwardRef(
  (
    props: KeyboardDatePickerProps,

    ref: ForwardedRef<HTMLDivElement>
  ) => {
    const fullscreenElement = useFullscreenElement();

    return (
      <MuiKeyboardDatePicker
        PopoverProps={{
          container: fullscreenElement || document?.body,
        }}
        inputProps={{
          ref,
        }}
        {...props}
      />
    );
  }
);

export default KeyboardDatePicker as typeof MuiKeyboardDatePicker;
